import {
  Box,
  Button, IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow, Tooltip,
  Typography
} from "@mui/material";
import Snapshot from "../../../../model/Snapshot";
import {dateToLocalFormat, numberToMoneyFormat} from "../../../../stores/StoreUtilities";
import {SnapshotIcon} from "../../../../styles/Icons";
import React from "react";
import {IBudgetCalc} from "../../../../components/calculator/Calculator";
import EditIcon from "@mui/icons-material/Edit";
import DifferenceIcon from "@mui/icons-material/Difference";
import Model from "../../../../model/Model";

const BudgetHistoryTable = ({
  model,
  budgetCalcs,
  snapshots,
  selected,
  onSelect,
  onNew,
  onEdit,
  onCompare
} : {
  model: Model
  budgetCalcs: IBudgetCalc[]
  snapshots: Snapshot[]
  selected?: Snapshot
  onSelect?(snapshot?: Snapshot): void
  onNew?(snapshot?: Snapshot): void
  onEdit?(snapshot: Snapshot): void
  onCompare?(snapshot: Snapshot): void
}) => {

  const styles = {
    smallButton: {
      height: 30,
    }
  }

  const isLocked = model.isLocked()

  const handleNewSnapshot = () => {
    if (onNew) {
      onNew(selected)
    }
  }

  const handleSelectSnapshot = (snapshot: Snapshot) => {
    if (onSelect) {
      onSelect(snapshot)
    }
  }

  const handleEditSnapshot = (snapshot: Snapshot) => {
    if (onEdit) {
      onEdit(snapshot)
    }
  }

  const handleCompareSnapshot = (snapshot: Snapshot) => {
    if (onCompare) {
      onCompare(snapshot)
    }
  }

  return (
    <Box display="flex" flexGrow={1} flexDirection="column" mt={2}>
      <Box display="flex" flexGrow={1} justifyContent="space-between" maxHeight={40}>
        <Typography variant="h3" color="primary" gutterBottom>Snapshots</Typography>
        <Button size="small" onClick={handleNewSnapshot} variant="outlined" sx={styles.smallButton} disabled={isLocked}>New</Button>
      </Box>
      <TableContainer component={Paper}>
        <Table size="small" width="100%">
          <TableHead>
            <TableRow>
              <TableCell width={30}></TableCell>
              <TableCell>Date</TableCell>
              <TableCell align="right">Income</TableCell>
              <TableCell align="right">Deductions</TableCell>
              <TableCell align="right">Estimated Taxes</TableCell>
              <TableCell align="right">Essential Expenses</TableCell>
              <TableCell align="right">Discretionary Expenses</TableCell>
              <TableCell align="right">Surplus/Shortfall</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {budgetCalcs.map((c: IBudgetCalc, index: number) => {
              const taxes = (c.totalEstimatedTaxes > 0) ? c.totalEstimatedTaxes : c.totalTaxes
              const surplus = c.totalIncome - c.totalDeductions - taxes - c.totalExpenses
              return (<TableRow selected={selected && selected.id === snapshots[index].id} key={`row${index}`}
                        onClick={() => {handleSelectSnapshot(snapshots[index])}}>
                    <TableCell><SnapshotIcon snapshotType={snapshots[index].snapshotType}/></TableCell>
                    <TableCell>{snapshots[index] && snapshots[index].id === "current" ? "Current" : dateToLocalFormat(c.date)}</TableCell>
                    <TableCell align="right">{numberToMoneyFormat(c.totalIncome, 0)}</TableCell>
                    <TableCell align="right">{numberToMoneyFormat(-c.totalDeductions, 0)}</TableCell>
                    <TableCell align="right">{numberToMoneyFormat(-taxes, 0)}</TableCell>
                    <TableCell align="right">{numberToMoneyFormat(-c.totalEssentialExpenses, 0)}</TableCell>
                    <TableCell align="right">{numberToMoneyFormat(-c.totalDiscretionaryExpenses, 0)}</TableCell>
                    <TableCell align="right">{numberToMoneyFormat(surplus, 0)}</TableCell>
                    <TableCell align="left" sx={{whiteSpace:"nowrap"}}>
                      <IconButton  disabled={isLocked} onClick={() => handleEditSnapshot(snapshots[index])}>
                        <EditIcon/>
                      </IconButton>
                      {selected && selected.id !== snapshots[index].id &&
                        <Tooltip title="Compare snapshots">
                          <IconButton disabled={isLocked} onClick={(event: any) => {
                            event.stopPropagation()
                            handleCompareSnapshot(snapshots[index])
                          }}>
                            <DifferenceIcon/>
                          </IconButton>
                        </Tooltip>
                      }
                    </TableCell>
                  </TableRow>
                )
              }
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default BudgetHistoryTable